<template>
  <div
    class="arrow-link"
    @mouseover="arrowHov = true"
    @mouseleave="arrowHov = false"
    :style="'transform: rotate(' + rotation + 'deg)'"
  >
    <slot></slot>
    <div class="arrow">
      <svg
        width="94"
        height="12"
        viewBox="0 0 94 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" fill="none" fill-rule="evenodd" stroke-linecap="round">
          <g
            transform="translate(-3.000000, -1.000000)"
            :stroke="this.col"
            stroke-width="2"
          >
            <path :d="'M4,7 L' + animatedPos + ',7'"></path>
            <path
              :d="'M' + (animatedPos - 4) + ',12 L' + animatedPos + ',7'"
            ></path>
            <path
              :d="'M' + (animatedPos - 4) + ',2 L' + animatedPos + ',7'"
            ></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "arrowThingy",
  props: {
    rotation: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      arrowHov: false,
      pos: 76,
      tweenedPos: 76,
      col: "hotpink",
    };
  },

  computed: {
    animatedPos() {
      return this.tweenedPos;
    },
    animatedCol() {
      return this.tweenedCol;
    },
  },

  watch: {
    pos(nv) {
      //either 96 or 76
      gsap.to(this.$data, {
        duration: 0.5,
        tweenedPos: nv,
        ease: "Ease.inOut",
      });
    },

    arrowHov(nv) {
      if (nv === true) {
        this.pos = 96;
      } else {
        this.pos = 66;
      }
    },
  },
};
</script>

<style lang="scss">
.arrow-link {
  display: flex;
  align-items: center;
  cursor: pointer;
  // if router link inside slot add small margin
  a {
    margin-right: 1rem;
    display: inline-block;
    line-height: 1.5;
  }

  .arrow {
    flex-grow: 0;
    flex-shrink: 1;
    display: flex;
  }
}
</style>
